import { forwardRef } from 'react';
import history from '../../../browserHistory';
import ChevronRight from '../../../images/arrow_right.svg';
import defaultProfile from '../../../images/HY_tooth.png';
import HeartBorderedIcon from '../../../images/icons/HeartBorderedIcon';
import ratingIcon from '../../../images/star_icon.svg';
import shieldCheckIcon from '../../../images/shield-check.svg';
import { Colors } from '../../../themes/colors';
import {
  fireConfirmCandidateOverviewClicked,
  fireConfirmCandidateProfileClicked,
} from '~/posthogs/events';
import { CompanyMatchLabel } from '../../CandidateList/components/UserCard/components/CompanyMatchLabel';
import { ConfirmOrDecline } from './ConfirmOrDecline';
import { Row, Text } from '~/commonComponents';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { EnablePermanentJobM2M } from '~/constants/ff.posthog';

export const CandidateHeader = forwardRef(
  (
    {
      isFavorite,
      candidate,
      jobId,
      job,
      jobPostingId,
      notesForTemp,
      allowNavigation,
      onDeclineConfirmed,
      isHasBackgroundCheck,
    },
    ref,
  ) => {
    const isEnablePermanentJobM2M = useFeatureFlag(EnablePermanentJobM2M);

    return (
      <div
        ref={ref}
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          marginBottom: 20,
          marginTop: 8,
          height: 120,
        }}
      >
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingLeft: isHasBackgroundCheck ? 20 : 40,
            paddingRight: 40,
          }}
        >
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <div
              style={{
                position: 'relative',
                width: 104,
                height: 104,
                borderRadius: 104,
                alignItems: 'center',
                justifyContent: 'center',
                border: `3px solid ${isFavorite ? Colors.favorites_400 : 'transparent'}`,
                padding: 2,
              }}
            >
              {candidate && candidate.profile_image ? (
                <img
                  src={candidate.profile_image}
                  style={{
                    width: 104,
                    height: 104,
                    borderRadius: 104,
                    objectFit: 'cover',
                  }}
                  alt="profile_image"
                />
              ) : (
                <div className="default_circle_container">
                  <img src={defaultProfile} alt="profile_image" width="104px" />
                </div>
              )}
              {isFavorite && (
                <div style={{ position: 'absolute', top: '72%', right: -4 }}>
                  <HeartBorderedIcon />
                </div>
              )}
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 20,
              }}
            >
              <div style={{ marginLeft: 20 }}>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginTop: 15,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <b
                      style={{
                        fontSize: 20,
                        color: Colors.neutral_600,
                        fontFamily: 'Nunito',
                        margin: '0px 7px 0px 0px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: 280,
                      }}
                    >
                      {`${candidate?.first_name} ${candidate?.last_name}`}
                    </b>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <img
                        src={ratingIcon}
                        alt="green"
                        style={{
                          width: 20,
                          height: 20,
                          margin: '0px 5px 3px 0px',
                        }}
                      />
                      <b
                        style={{
                          fontSize: 16,
                          marginRight: 5,
                          color: Colors.neutral_600,
                          fontFamily: 'Nunito',
                        }}
                      >
                        {candidate?.average_rating?.toFixed(1) || '5.0'}
                      </b>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        alignSelf: 'center',
                        height: 16,
                        marginLeft: 8,
                        marginRight: 8,
                        border: `1px solid ${Colors.neutral_600}`,
                      }}
                    />

                    <div
                      className="global_font f-20"
                      style={{
                        marginLeft: 4,
                        display: 'flex',
                        gap: 8,
                        color: Colors.secondary_500,
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        alignItems: 'center',
                      }}
                      onClick={() => {
                        if (isEnablePermanentJobM2M) {
                          fireConfirmCandidateOverviewClicked({
                            interviewId: jobId,
                            postingId: jobPostingId,
                            professionalId: candidate.id,
                          });

                          history.push(
                            `/permanent-jobs/postings/${jobPostingId}/candidates/${candidate.id}/overview`,
                          );
                        } else {
                          fireConfirmCandidateProfileClicked({ shiftId: jobId });

                          history.push(`/dashboard/candidate/${jobId}`, {
                            candidateId: candidate?.id,
                            state: job?.state,
                            profession: job?.profession,
                          });
                        }
                      }}
                    >
                      {isEnablePermanentJobM2M ? 'Overview' : 'Profile'}
                      <img src={ChevronRight} alt="arrow" style={{ width: 16, height: 16 }} />
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    fontFamily: 'Nunito',
                    fontSize: 16,
                    color: Colors.neutral_600,
                  }}
                >
                  Drivers License Verified
                </div>

                <Row alignItems="center">
                  <Text>
                    {candidate?.license?.subProfession ?? candidate?.license?.profession}{' '}
                    Credentials Verified
                  </Text>
                  {isHasBackgroundCheck && (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          alignSelf: 'center',
                          height: 16,
                          marginLeft: 8,
                          marginRight: 8,
                          border: `1px solid ${Colors.neutral_500}`,
                        }}
                      />
                      <Row alignItems="center" gap={4}>
                        <Text>Background Checked</Text>
                        <img
                          src={shieldCheckIcon}
                          alt="shield-check"
                          style={{
                            width: 24,
                            height: 24,
                            margin: '0px 0px 0px 0px',
                          }}
                        />
                      </Row>
                    </>
                  )}
                </Row>
                <CompanyMatchLabel professional={candidate} job={job} />
              </div>
            </div>
          </div>
          <ConfirmOrDecline
            candidateId={candidate?.id}
            notesForTemp={notesForTemp}
            allowNavigation={allowNavigation}
            onDeclineConfirmed={onDeclineConfirmed}
          />
        </div>
      </div>
    );
  },
);
